import { colorPalette } from '../../colorPalette';
export const blockStyle = {
    borderRadius: '8px',
    border: `1px solid ${colorPalette.gray200}`,
};
export const headerStyle = {
    padding: '4px 8px 4px 12px',
    background: colorPalette.gray100,
};
export const titleStyle = {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    color: colorPalette.gray700,
    fontWeight: '600',
    padding: '8px 0',
};
export const contentStyle = {
    padding: '12px',
};
